import React, { useState } from "react"
import { IconButton, makeStyles, Tooltip } from "@material-ui/core"
import ConfirmAlert from "../Alerts/ConfirmAlert"

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.warning.main,
  },
}))

const RemoveIconButton = ({ onConfirmedClick, onCancelledClick, subject, children, classes, ...props }) => {
  const defaultClasses = useStyles()
  const [confirming, setConfirming] = useState(false)

  const handleClick = () => setConfirming(true)

  const handleResponse = (confirmed) => {
    setConfirming(false)
    if (confirmed && onConfirmedClick) onConfirmedClick()
    else if (!confirmed && onCancelledClick) onCancelledClick()
  }

  return (
    <>
      <ConfirmAlert open={confirming} title={`Remove ${subject}`} onClose={handleResponse} />

      <Tooltip title={`Remove ${subject}`}>
        <IconButton onClick={handleClick} classes={classes || defaultClasses} {...props}>
          {children}
        </IconButton>
      </Tooltip>
    </>
  )
}

export { RemoveIconButton }
